"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
/**
 * Создание лога из кастомных ошибок @cian/peperrors
 *
 * @export
 * @param {IEnvelopeParams} params - параметры
 * @param {Error} error - объект нативной ошибки
 * @param {TMeta} [meta] - мета информация
 * @returns {IErrorEnvelope}
 */
function createEnvelopeFromPeperror(params, error, meta) {
    if (meta === void 0) { meta = {}; }
    var application = params.application, type = params.type, version = params.version;
    // FIXME: Сделать domain отдельным полем в индексах
    var metaKV = utils_1.convertMetaToKeyValue(__assign(__assign({}, meta), { domain: error.domain }));
    return {
        application: application,
        date: (new Date()).toISOString(),
        name: error.type,
        message: error.message,
        meta: metaKV,
        stack: error.stack,
        // FIXME: переделать в поле details
        other: utils_1.convertMetaToKeyValue(error.details),
        type: type,
        version: version,
    };
}
exports.createEnvelopeFromPeperror = createEnvelopeFromPeperror;
/**
 * Создание лога из нативной ошибки {Error}
 *
 * @export
 * @param {IEnvelopeParams} params - параметры
 * @param {Error} error - объект нативной ошибки
 * @param {TMeta} [meta] - мета информация
 * @returns {IErrorEnvelope}
 */
function createEnvelopeFromNativeError(params, error, meta) {
    var application = params.application, type = params.type, version = params.version;
    var errorInfo = getErrorInfoFromNativeError(error);
    var cause = [];
    var currentError = error;
    // FIXME: Старое легаси из @cian/http-client
    // tslint:disable-next-line:no-any
    while (currentError.cause) {
        // tslint:disable-next-line:no-any
        currentError = currentError.cause;
        cause.push(getErrorInfoFromNativeError(currentError));
    }
    return {
        type: type,
        name: errorInfo.name,
        message: errorInfo.message,
        stack: errorInfo.stack,
        other: errorInfo.other,
        cause: cause,
        date: (new Date()).toISOString(),
        application: application,
        version: version,
        meta: meta ? utils_1.convertMetaToKeyValue(meta) : [],
    };
}
exports.createEnvelopeFromNativeError = createEnvelopeFromNativeError;
function getErrorInfoFromNativeError(error) {
    var other = Object.keys(error)
        .filter(function (key) { return key !== 'name' && key !== 'message' && key !== 'stack'; })
        .reduce(function (acc, key) {
        acc[key] = error[key]; // tslint:disable-line:no-any
        return acc;
        // tslint:disable-next-line:no-any no-object-literal-type-assertion
    }, {});
    return {
        name: String(error.name || error.constructor.name || ''),
        message: String(error.message),
        stack: String(error.stack),
        other: utils_1.convertMetaToKeyValue(other),
    };
}
//# sourceMappingURL=envelope.js.map